import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["sadad", "hasSadad"];
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import RemainingPaymentComponent from "@/_MiniApps/RemainingPaymentComponent/RemainingPaymentComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from "./Paylink.module.css";
import { useTranslation } from "@i18n";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import useButtonLoading from "@hooks/useButtonLoading";
var PayLink = function PayLink() {
  var _remainingOrder$payme, _remainingOrder$payme2;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var fullPageData = useFullPageData();
  var _useState = useState(null),
    sadadError = _useState[0],
    setSadadError = _useState[1];
  var sadad = fullPageData.sadad,
    hasSadad = fullPageData.hasSadad,
    remainingOrder = _objectWithoutProperties(fullPageData, _excluded);
  var buttonLoading = useButtonLoading();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hideAppBanner: true,
    authenticationMsg: true,
    headHideLinks: true,
    hideOrangeHeadBtn: true,
    hasNavBar: true,
    mobileHasBack: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, remainingOrder && Object.keys(remainingOrder).length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.remainingContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.remainingCardContainer
  }, /*#__PURE__*/React.createElement(RemainingPaymentComponent, {
    isCash: true,
    buttonLoading: buttonLoading,
    order: remainingOrder,
    sadad: sadad,
    hasSadad: hasSadad,
    sadadError: sadadError,
    banks: remainingOrder && (remainingOrder === null || remainingOrder === void 0 ? void 0 : (_remainingOrder$payme = remainingOrder.paymentOptions) === null || _remainingOrder$payme === void 0 ? void 0 : _remainingOrder$payme.banks),
    enableAllPayments: remainingOrder && (remainingOrder === null || remainingOrder === void 0 ? void 0 : (_remainingOrder$payme2 = remainingOrder.paymentOptions) === null || _remainingOrder$payme2 === void 0 ? void 0 : _remainingOrder$payme2.enabled),
    title: t("collect_remaining_amount", {
      ns: "web_common"
    }),
    showBackLink: true,
    updateSadadError: setSadadError,
    date: null
  }))) : null));
};
export default PayLink;